import {
  DEFAULT_CLOUD_TYPES,
  DEFAULT_ENGINEER_ROLES,
  DEFAULT_PRODUCT_TYPES,
  DEFAULT_PROJECT_MANAGER_ROLES,
} from "resource-planner-model";
import {
  ApplicationConfigAction,
  ApplicationConfigState,
  FETCH_APPLICATION_CONFIG,
  LOAD_APPLICATION_CONFIG,
} from "./ApplicationConfigTypes";

const initialState: ApplicationConfigState = {
  item: {
    id: "application-config",
    corporateEmailDomains: [],
    cloudTypes: DEFAULT_CLOUD_TYPES,
    engineerRoles: DEFAULT_ENGINEER_ROLES,
    productTypes: DEFAULT_PRODUCT_TYPES,
    projectManagerRoles: DEFAULT_PROJECT_MANAGER_ROLES,
    plugins: {
      jira: {
        enabled: false,
        host: "",
        syncSchedule: "",
        groupIdsEM: [],
        groupIdsEngineer: [],
      },
      harvest: {
        enabled: false,
        harvestToTeamsSchedule: "",
        cacheExpirationInSeconds: 28800,
        opsTaskIds: [],
      },
      microsoftTenant: {
        tenantId: "",
        graphEndpoint: "https://graph.microsoft.com/v1.0",
        aadEndpoint: "https://login.microsoftonline.com",
        graphApiVersion: "v1.0",
        scopes: ["https://graph.microsoft.com/.default"],
      },
      microsoftShifts: {
        enabled: false,
        teamIds: [],
        markedOutSyncEnabled: true,
      },
    },
  },
};

export default function applicationConfigReducer(
  state = initialState,
  action: ApplicationConfigAction
): ApplicationConfigState {
  switch (action.type) {
    case FETCH_APPLICATION_CONFIG:
      return state;
    case LOAD_APPLICATION_CONFIG:
      return {
        item: action.item,
      };
    default:
      return state;
  }
}
